package com.tovtalk.domain.repository

import com.tovtalk.domain.entity.Post
import com.tovtalk.domain.entity.DomainResult

data class HashtagInfo(val hashtag: String, val postCount: Int)

interface HashtagRepository {
    suspend fun getPostsByHashtag(
        tag: String,
        limit: Int = 20,
        cursor: String? = null
    ): DomainResult<Pair<List<Post>, String?>>

    suspend fun getTrending(limit: Int = 20): DomainResult<List<HashtagInfo>>

    suspend fun searchHashtags(query: String, limit: Int = 10): DomainResult<List<HashtagInfo>>
}
